import {
  initialCustomLabForPreset,
  LAB_CATEGORY_ORDER,
  isLayerActive,
} from '../../makeup-flux-lab/utils/labMakeupSchema';
import { CUSTOM_CATEGORY_OPTIONS } from '../../makeup-flux-lab/utils/makeupCustomOptions';

export function hasActiveMakeupLab(lab) {
  if (!lab || typeof lab !== 'object') return false;
  return LAB_CATEGORY_ORDER.some((cat) => isLayerActive(lab[cat]));
}

export function resetMakeupLabAllNone() {
  return initialCustomLabForPreset({});
}

/** Categories the UI can configure (must have option list). */
export function configurableCategories() {
  return LAB_CATEGORY_ORDER.filter((cat) => (CUSTOM_CATEGORY_OPTIONS[cat] || []).length > 0);
}

const BLEND_CATS = ['blush', 'eyeshadow', 'highlighter', 'contour'];

/** Mirror backend evaluate_makeup_lab_v3 for instant UI warnings. */
export function evaluateMakeupLabAdvisory(lab) {
  const active = LAB_CATEGORY_ORDER.filter((cat) => isLayerActive(lab?.[cat]));
  const warnings = [];
  if (!active.length) {
    return { activeCategories: [], warnings: [], autoFoundationRecommended: false, lipOnly: false };
  }
  const hasBase = isLayerActive(lab?.foundation) || isLayerActive(lab?.concealer);
  const lipOnly =
    isLayerActive(lab?.lipstick) &&
    active.every((c) => c === 'lipstick' || c === 'eyebrows');

  const blendActive = BLEND_CATS.filter((c) => active.includes(c));
  let autoFoundationRecommended = false;
  if (blendActive.length && !hasBase) {
    autoFoundationRecommended = true;
    warnings.push({
      code: 'AUTO_FOUNDATION_RECOMMENDED',
      severity: 'warning',
      message:
        'Without foundation, blending may touch more of the face or add unlisted cheek/eye color. ' +
        'Keep “Sheer auto foundation” on for even blending, or pick Foundation manually.',
      categories: blendActive,
    });
  }
  if (
    (active.includes('eyeshadow') || active.includes('eyeliner') || active.includes('eyelash')) &&
    !hasBase
  ) {
    warnings.push({
      code: 'EYES_WITHOUT_BASE',
      severity: 'info',
      message: 'Eye makeup without base: lids only — facial skin stays identical to the upload.',
    });
  }
  if (active.includes('concealer') && !active.includes('foundation')) {
    warnings.push({
      code: 'CONCEALER_WITHOUT_FOUNDATION',
      severity: 'info',
      message: 'Concealer alone may look patchy; consider sheer foundation or lower concealer strength.',
    });
  }
  if (lipOnly) {
    warnings.push({
      code: 'LIP_ONLY',
      severity: 'info',
      message: 'Lip-only: only lip pigment changes; cheeks, eyes, and skin stay untouched.',
    });
  }
  return {
    activeCategories: active,
    warnings,
    autoFoundationRecommended,
    lipOnly,
  };
}
